import { render, staticRenderFns } from "./DynamicFiltersSave.vue?vue&type=template&id=50da68cd&scoped=true"
import script from "./DynamicFiltersSave.vue?vue&type=script&lang=js"
export * from "./DynamicFiltersSave.vue?vue&type=script&lang=js"
import style0 from "./DynamicFiltersSave.vue?vue&type=style&index=0&id=50da68cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50da68cd",
  null
  
)

export default component.exports